import { Inject, Injectable, Injector } from '@angular/core';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';

import { Utilities_OperationService } from './Utilities.operation.service';
import { Totes_OperationService } from './Totes.operation.service';
import { ProgrammableLogicController_OperationService } from './ProgrammableLogicController.operation.service';


@Injectable({ providedIn: 'root' })
export class app_OperationService {

  constructor(
    private injector: Injector,
    private $utils: UtilsService,
  ) {
    this.Utilities = this.injector.get(Utilities_OperationService);
    this.Totes = this.injector.get(Totes_OperationService);
    this.ProgrammableLogicController = this.injector.get(ProgrammableLogicController_OperationService);
  }

    public Utilities: Utilities_OperationService;
    public Totes: Totes_OperationService;
    public ProgrammableLogicController: ProgrammableLogicController_OperationService;
  public app: app_OperationService = this;


  private isAuthorized(operationName: string): Promise<boolean> {
    return this.$utils.http.post(`${environment.backendUrl}api/app/operations/${operationName}/isauthorized`, null);
  }
}
